var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQueryClient, } from "@tanstack/react-query";
import { useAccountSummaryV2Query as useAccountSummaryQuery, useCreditAccountsQuery, } from "syf-api";
import { useRewardsBalanceQuery } from "syf-api/rewardsBalance";
import { useRewardsCertificateQuery } from "syf-api/rewardsCertificate";
import getApiConfig from "../helpers/getApiConfig";
var useCreditAccounts = function (config, queryOptions) {
    var queryClient = useQueryClient();
    var enabledQuery = Boolean(sessionStorage.getItem("accessToken"));
    var apiConfig = getApiConfig(queryClient, config, enabledQuery, queryOptions);
    return useCreditAccountsQuery(__assign({ keyProps: undefined }, apiConfig));
};
var useAccountSummary = function (accountId, config) {
    var queryClient = useQueryClient();
    var apiConfig = getApiConfig(queryClient, config, Boolean(accountId));
    return useAccountSummaryQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
var useRewardsBalance = function (_a) {
    var accountId = _a.accountId, config = _a.config, hasRewardsBalance = _a.hasRewardsBalance;
    var queryClient = useQueryClient();
    var apiConfig = {
        config: config,
        queryOptions: __assign(__assign({}, queryClient.getQueryDefaults()), { enabled: !!accountId && hasRewardsBalance && !!config.clientId }),
    };
    return useRewardsBalanceQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
var useRewardsCertificate = function (_a) {
    var accountId = _a.accountId, config = _a.config, certificateRequestType = _a.certificateRequestType, hasCertificateHistory = _a.hasCertificateHistory;
    var queryClient = useQueryClient();
    var apiConfig = {
        config: config,
        queryOptions: __assign(__assign({}, queryClient.getQueryDefaults()), { enabled: !!accountId &&
                !!certificateRequestType &&
                !!config.clientId &&
                hasCertificateHistory }),
    };
    return useRewardsCertificateQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid", certificateRequestType: certificateRequestType } }, apiConfig));
};
export { useAccountSummary, useCreditAccounts, useRewardsBalance, useRewardsCertificate, };
